// extracted by mini-css-extract-plugin
export default {"checkboxCell":"checkbox-form-cell_checkboxCell__evNE3"};